import React from 'react'
import { useRecoilValue } from 'recoil'
import { DataTable, Text } from '@/presentation/components'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { DateAdapter } from '@/data/protocols'
import { styles } from '../../styles'

type OsWarehouseProps = {
  dateAdapter: DateAdapter
}

export const OsWarehouse: React.FC<OsWarehouseProps> = ({
  dateAdapter
}) => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)

  return (
    <>
      {!!serviceOrderDetail.listaNFOS?.length &&
        <>
          <Text style={styles.pageInfo}>Eventos do Almoxarifado</Text>
          <DataTable>
            <DataTable.Header>
              <DataTable.Title>Data</DataTable.Title>
              <DataTable.Title>Ocorrência</DataTable.Title>
              <DataTable.Title>Estoque</DataTable.Title>
              <DataTable.Title>Nota Fiscal</DataTable.Title>
              <DataTable.Title>Código</DataTable.Title>
              <DataTable.Title>Produto</DataTable.Title>
              <DataTable.Title>Quantidade</DataTable.Title>
              <DataTable.Title>Usuário</DataTable.Title>
            </DataTable.Header>

            {serviceOrderDetail.listaNFOS.map((almoxarifado, index) => (
              <DataTable.Row key={index}>
                  <DataTable.Cell>{dateAdapter.format(almoxarifado.dataMovimento, 'DD/MM/yyyy')}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.ocorrencia}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.estoque}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.nota}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.codigo}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.produto}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.quantidade}</DataTable.Cell>
                  <DataTable.Cell>{almoxarifado.usuario}</DataTable.Cell>
              </DataTable.Row>
            ))}
          </DataTable>
        </>
      }
    </>
  )
}
